__turbopack_context__.v({
  "closeButton": "Modal-module-scss-module__UtPkAq__closeButton",
  "dialog": "Modal-module-scss-module__UtPkAq__dialog",
  "header": "Modal-module-scss-module__UtPkAq__header",
  "logoLink": "Modal-module-scss-module__UtPkAq__logoLink",
  "stack-module-0": "Modal-module-scss-module__UtPkAq__stack-module-0",
  "stack-module-1": "Modal-module-scss-module__UtPkAq__stack-module-1",
  "stack-module-10": "Modal-module-scss-module__UtPkAq__stack-module-10",
  "stack-module-11": "Modal-module-scss-module__UtPkAq__stack-module-11",
  "stack-module-12": "Modal-module-scss-module__UtPkAq__stack-module-12",
  "stack-module-13": "Modal-module-scss-module__UtPkAq__stack-module-13",
  "stack-module-14": "Modal-module-scss-module__UtPkAq__stack-module-14",
  "stack-module-15": "Modal-module-scss-module__UtPkAq__stack-module-15",
  "stack-module-16": "Modal-module-scss-module__UtPkAq__stack-module-16",
  "stack-module-17": "Modal-module-scss-module__UtPkAq__stack-module-17",
  "stack-module-18": "Modal-module-scss-module__UtPkAq__stack-module-18",
  "stack-module-19": "Modal-module-scss-module__UtPkAq__stack-module-19",
  "stack-module-2": "Modal-module-scss-module__UtPkAq__stack-module-2",
  "stack-module-20": "Modal-module-scss-module__UtPkAq__stack-module-20",
  "stack-module-3": "Modal-module-scss-module__UtPkAq__stack-module-3",
  "stack-module-4": "Modal-module-scss-module__UtPkAq__stack-module-4",
  "stack-module-5": "Modal-module-scss-module__UtPkAq__stack-module-5",
  "stack-module-6": "Modal-module-scss-module__UtPkAq__stack-module-6",
  "stack-module-7": "Modal-module-scss-module__UtPkAq__stack-module-7",
  "stack-module-8": "Modal-module-scss-module__UtPkAq__stack-module-8",
  "stack-module-9": "Modal-module-scss-module__UtPkAq__stack-module-9",
  "wrapper": "Modal-module-scss-module__UtPkAq__wrapper",
  "z-base": "Modal-module-scss-module__UtPkAq__z-base",
  "z-content": "Modal-module-scss-module__UtPkAq__z-content",
  "z-footer": "Modal-module-scss-module__UtPkAq__z-footer",
  "z-header": "Modal-module-scss-module__UtPkAq__z-header",
  "z-hero": "Modal-module-scss-module__UtPkAq__z-hero",
  "z-logo": "Modal-module-scss-module__UtPkAq__z-logo",
  "z-logo-effect": "Modal-module-scss-module__UtPkAq__z-logo-effect",
  "z-navigation": "Modal-module-scss-module__UtPkAq__z-navigation",
  "z-sub": "Modal-module-scss-module__UtPkAq__z-sub",
});
